<template>
  <div class="page">
    <!--video属性
                    webkit-playsinline ios 小窗播放，使视频不脱离文本流，安卓则无效
                    微信内置x5内核，
                    x5-video-player-type="h5-page" 启用H5播放器,是wechat安卓版特性，添加此属性，微信浏览器会自动将视频置为全屏
                    x5-video-player-fullscreen="true" 全屏设置，设置为 true 是防止横屏
                    x5-video-orientation 控制横竖屏 landscape 横屏，portrain竖屏； 默认portrain
                    poster：封面
                    src：播放地址
    -->
    <!-- <video
      id="videoRef"
      class="video_box"
      autoplay="autoplay"
      loop
      webkit-playsinline="true"
      x5-video-player-fullscreen="true"
      playsinline
      x5-video-player-type="h5-page"
      preload="auto"
      :src="url" 
      @click="pauseVideo" 
      @ended="onPlayerEnded($event)"
    ></video>

    <img
      v-show="iconPlayShow"
      class="icon_play"
      @click="playvideo"
      src="https://img.zhanshangxiu.com/showonline/file/202008/c527ae078eec45e0b5d86bc167ce8b12.png"
    /> -->
    <!-- 直播背景 -->
    <!-- <img
      class="play"
      :style="liveStatus === 3 || liveStatus === 0 ||liveStatus === 2?'filter: blur(0.1rem);':''"
      :src="cover"
      v-if="isVideoShow"
      style="opcity: 0.4"
    /> -->
    
    <div id="id_test_video" ref="tcPlayer" style="width:100%; height:auto;"></div>

  </div>
</template>
 <!--[if lt IE 9]>
    <script src="https://imgcache.qq.com/open/qcloud/video/vcplayer/libs/es5-shim.js"></script>
    <script src="https://imgcache.qq.com/open/qcloud/video/vcplayer/libs/es5-sham.js"></script>
<![endif]-->
<script src="../../../assets/js/TcPlayer-2.3.2.js"></script>
<script>
export default {
  name: "live-video",
  props: {
    url: {
      type: String,
      default: ""
    },
    cover: {
      type: String,
      default:
        "https://img.zhanshangxiu.com/showonline/file/202009/5834de2fce5d4505981eb13e80521b8b.png"
    },
    liveStatus: {
      type: Number,
      default: 0
    },
    showBg: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      item: {
        url:
          "https://1256993030.vod2.myqcloud.com/d520582dvodtransgzp1256993030/7732bd367447398157015849771/v.f30.mp44",
        // url:
        //   "http://video.jishiyoo.com/3720932b9b474f51a4cf79f245325118/913d4790b8f046bfa1c9a966cd75099f-8ef4af9b34003bd0bc0261cda372521f-ld.mp4", //视频源
        // url:
        //   "https://live.zhanshangxiu.com/showonline/1c56ca7e-02ed-410d-ae51-2db87ec842e4.m3u8?auth_key=1589626306-0-0-6bd2a8199fd9e1f9a2a4110126a90b0e", //视频源
        cover: "http://oss.jishiyoo.com/images/file-1575341210559.png" //封面
      },
      isVideoShow: true,
      playOrPause: true,
      iconPlayShow: true
    };
  },
  mounted() {
    this.init();
    
    // this.init2();
  },
  methods: {
    //滑动改变播放的视频
    // init(index) {
    //   //改变的时候 暂停当前播放的视频
    //   console.log(this.url,this.liveStatus,'-----------')
    //   let video = document.getElementById("videoRef");
    //   video.play();
    //   this.playOrPause = false;
    //   const that = this;
    //   // 进入全屏监听  视频自动播放并全屏
    //   video.addEventListener("x5videoexitfullscreen", function() {
    //     that.playvideo();
    //   });
    //   video.addEventListener("error", function(e) {
    //     that.iconPlayShow = true;
    //     that.isVideoShow = true; 
    //     console.log("视频出错！");
    //   });
    // },
      init(){
        var player =  new TcPlayer('id_test_video', {
              "m3u8": this.url,
              "autoplay" : true,      //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
              "poster" : {"style":"stretch", "src":this.cover},
              "controls":'system',
              "systemFullscreen":true,
              "width" :  '480',//视频的显示宽度，请尽量使用视频分辨率宽度
              "height" : '320'//视频的显示高度，请尽量使用视频分辨率高度
            });
        
        this.$nextTick(()=>{
          let videoDom = document.querySelector("video")
          if(typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function"){
              WeixinJSBridge.invoke('getNetworkType', {}, function (res) {
                  videoDom.play();
              });
          }
        })
      }
        
    
    // 开始播放
    // playvideo(event) {
    //   let video = document.getElementById("videoRef");
    //   this.isVideoShow = false;
    //   this.iconPlayShow = false;
    //   video.play();
    //   window.onresize = function() {
    //     video.style.width = window.innerWidth + "px";
    //     video.style.height = window.innerHeight + "px";
    //   };
    // },
    // pauseVideo() {
    //   //暂停\播放
    //   let video = document.getElementById("videoRef");
    //   video.play();
    //   this.iconPlayShow = false;
    // },
    // onPlayerEnded(player) {
    //   //视频结束
    //   this.isVideoShow = true;
    // }, 
  }
};
</script>

<style lang="scss">
html {
  video::-webkit-media-controls-fullscreen-button {
    display: none !important;
  }
}
</style>
<style lang="scss" scoped>
.page {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
  object-fit: fill;
  
}
.video-player {
  width: 100%;
  height: 100%;
  background-color: #000;
}
.video_box {
  object-fit: fill !important;
  background: #131825;
  z-index: 88;
  position: absolute;
  overflow: hidden;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.icon_play {
  position: absolute;
  top: 44%;
  right: 0;
  left: 0;
  bottom: auto;
  margin: auto;
  z-index: 90;
  height: 40px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
}

.play,
.platStart {
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 89;
  width: 100%;
  height: 100%;
}
.play{
  // object-fit: cover;
}
.vcp-player{
  height: 4.3rem;
}
video{
  height: 4.3rem;
}
</style>